export { default } from './WithImage';
